import React, { ReactElement, RefObject, KeyboardEvent } from 'react';
import { createPopper, Instance, Placement } from '@popperjs/core';
import './Tooltip.scss';
import { TooltipContent } from './TooltipContent';

export default class Tooltip extends React.Component<Props, State>{
	private readonly targetRef: RefObject<HTMLDivElement>;
	private popper: Instance | null = null;
	
	constructor(props: Props) {
		super(props);
		this.state = { hovered: false, focused: false };
		this.targetRef = React.createRef<HTMLDivElement>();
	}

	render() {
		return (
			<React.Fragment>
				<div ref={this.targetRef} 
					 onMouseEnter={this.handleMouseEnter} 
					 onMouseLeave={this.handleMouseLeave} 
					 onFocus={this.handleFocus}
					 onBlur={this.handleBlur}
					 onKeyDown={this.handleKeyDown}
					 className="tooltip__target">{this.props.children}</div>
				{(this.state.hovered || this.state.focused) && (!!this.props.content || !!this.props.renderContent) && <TooltipContent content={this.props.content} renderContent={this.props.renderContent} tooltipRefCb={this.tooltipRefCb} />}
			</React.Fragment>
		);
	}

	componentWillUnmount() {
		this.cleanupPopper();
	}
	
	handleMouseEnter = () => {
		this.setState({ hovered: true });
	}
	
	handleMouseLeave = () => {
		this.setState({ hovered: false });
	}
	
	handleFocus = () => {
		this.setState({ focused: true });
	}
	
	handleBlur = () => {
		this.setState({ focused: false });
	}
	
	handleKeyDown = (e: KeyboardEvent) => {
		if (e.key === 'Escape') {
			this.setState({ focused: false });
		}
	}
	
	tooltipRefCb = (elm: HTMLDivElement | null): void => {
		if (elm) {
			this.cleanupPopper();
			
			if (this.targetRef.current) {
				this.popper = createPopper(this.targetRef.current, elm, {
					placement: this.props.placement,
					strategy: 'fixed',
					modifiers: [
						{ name: 'offset', options: { offset: [0, 10] } },
						...(!this.props.fallbackPlacements ? [] : [
							{
								name: 'flip',
								options: {
									fallbackPlacements: this.props.fallbackPlacements,
								}
							}
						])
					]
				})
			}
		} else {
			this.cleanupPopper();
		}
	};
	
	private cleanupPopper(): void {
		if (this.popper) {
			this.popper.destroy();
			this.popper = null;
		}
	}
}

interface Props {
	children: ReactElement;
    content?: string | nundefined;
    renderContent?: () => ReactElement;
    placement: Placement;
    fallbackPlacements?: Placement[];
}

interface State {
    hovered: boolean;
    focused: boolean;
}
